import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { SimpleHeader } from '../../components/layout/Header';
import SpecialistItem from '../../components/ui/SpecialistItem';
import { Button } from '../../components/common/Button';
import { 
  CheckIcon, 
  ChevronRightIcon,
  CalendarIcon,
  CreditCardIcon
} from '../../components/common/Icons';

// Specialists selection screen
export const SpecialistsScreen = () => {
  const { selectedSalon, selectedService, navigateTo } = useApp();
  
  // Use provided service or default
  const service = selectedService || {
    id: 1,
    name: "TUNS",
    duration: "45 min",
    price: "50 lei",
    description: "Tunsoare clasică sau modernă."
  };
  
  // Sample specialists data
  const specialists = [
    {
      id: 1,
      name: "Remus Bezea",
      position: "Specialist",
      available: true,
      price: "50 lei",
      duration: "45 min",
      image: "/api/placeholder/80/80"
    },
    {
      id: 2,
      name: "Cristi Gâtlan",
      position: "Specialist",
      available: true,
      price: "50 lei",
      duration: "45 min",
      image: "/api/placeholder/80/80"
    },
    {
      id: 3,
      name: "Alexandru Totolici",
      position: "Profil privat",
      available: true,
      price: "50 lei",
      duration: "45 min",
      image: "/api/placeholder/80/80",
      needsRegistration: true
    }
  ];
  
  return (
    <div className="flex flex-col h-full">
      <SimpleHeader 
        title="Alege specialist" 
        onBack={() => navigateTo('salon', { salon: selectedSalon })}
      />
      
      <div className="bg-gray-100 p-3 mx-4 mt-4 rounded-lg">
        <div className="flex items-center">
          <div className="w-6 h-6 bg-gray-300 rounded-full flex items-center justify-center mr-2">
            <CheckIcon size={16} />
          </div>
          <div>
            <h3 className="font-medium">{service.name}</h3>
            <div className="text-gray-600 text-sm">{service.duration}, {service.price}</div>
          </div>
        </div>
        <button className="w-full text-center text-blue-600 mt-3 py-2 bg-gray-50 rounded-lg">
          Adaugă încă un serviciu
        </button>
      </div>
      
      <div className="flex-1 overflow-y-auto p-4">
        <h2 className="text-xl font-bold mb-4">Alege specialist</h2>
        <div className="space-y-4">
          {specialists.map(specialist => (
            <SpecialistItem 
              key={specialist.id}
              name={specialist.name} 
              position={specialist.position} 
              available={specialist.available}
              price={specialist.price}
              duration={specialist.duration}
              image={specialist.image}
              needsRegistration={specialist.needsRegistration}
              onClick={() => navigateTo('selectDate', { 
                salon: selectedSalon, 
                service,
                specialist
              })}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

// Services selection screen
export const ServicesScreen = () => {
  const { selectedSalon, navigateTo } = useApp();
  
  const service = {
    id: 1,
    name: "TUNS",
    duration: "45 min",
    price: "50 lei",
    description: "Tunsoare clasică sau modernă."
  };

  return (
    <div className="flex flex-col h-full">
      <SimpleHeader 
        title="Alege serviciu" 
        onBack={() => navigateTo('salon', { salon: selectedSalon })}
      />
      
      <div className="flex-1 overflow-y-auto p-4">
        <h2 className="text-xl font-bold mb-4">SERVICIU ALES:</h2>
        <div className="space-y-4">
          <div className="bg-white rounded-lg shadow p-4">
            <div className="flex items-center">
              <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center mr-3">
                <CheckIcon size={16} className="text-white" />
              </div>
              <div className="flex-1">
                <h3 className="font-bold">{service.name}</h3>
                <div className="flex justify-between text-gray-600 text-sm">
                  <span>{service.duration}, {service.price}</span>
                </div>
              </div>
            </div>
          </div>
          
          <button className="w-full bg-gray-100 text-blue-600 py-3 rounded-lg text-center">
            Adaugă încă un serviciu
          </button>
          
          <Button 
            fullWidth
            size="lg"
            variant="primary"
            className="mt-8"
            onClick={() => navigateTo('specialists', { salon: selectedSalon, service })}
          >
            Continuă
          </Button>
        </div>
      </div>
    </div>
  );
};

// Date selection screen
export const SelectDateScreen = () => {
  const { selectedSalon, selectedService, selectedSpecialist, navigateTo } = useApp();
  const [selectedDate, setSelectedDate] = useState('21');
  const [selectedTime, setSelectedTime] = useState('14:15');
  
  const days = [
    { day: 'Lun.', date: '17', number: 17 },
    { day: 'Mar.', date: '18', number: 18 },
    { day: 'Azi', date: '19', number: 19 },
    { day: 'Joi', date: '20', number: 20 },
    { day: 'Vin.', date: '21', number: 21 },
    { day: 'Sâ...', date: '22', number: 22 },
    { day: 'Du...', date: '23', number: 23 },
  ];
  
  const times = ['14:15'];
  
  return (
    <div className="flex flex-col h-full">
      <SimpleHeader 
        title="Alege ora" 
        onBack={() => navigateTo('specialists', { 
          salon: selectedSalon,
          service: selectedService
        })}
      />
      
      <div className="flex-1 overflow-y-auto">
        <div className="p-4 border-b">
          <div className="flex justify-between items-center">
            <h2 className="text-lg">17-23 mar</h2>
            <button className="text-blue-600 flex items-center">
              Următor
              <ChevronRightIcon size={16} />
            </button>
          </div>
          
          <div className="flex justify-between mt-4">
            {days.map((day) => (
              <div 
                key={day.number}
                className={`flex flex-col items-center ${
                  selectedDate === day.date 
                    ? 'text-white' 
                    : day.number < 20 ? 'text-gray-300' : 'text-black'
                }`}
                onClick={() => day.number >= 20 && setSelectedDate(day.date)}
              >
                <span className="text-sm">{day.day}</span>
                <div 
                  className={`w-10 h-10 rounded-full flex items-center justify-center mt-2 ${
                    selectedDate === day.date 
                      ? 'bg-blue-600' 
                      : 'bg-transparent'
                  }`}
                >
                  {day.date}
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="p-4">
          <h3 className="text-lg font-medium mb-2">Ore disponibile 21 mar.</h3>
          <p className="text-gray-600 mb-4">(GMT+03:00) Ora Europei de Est - București</p>
          
          <div>
            {times.map((time) => (
              <div 
                key={time}
                className="p-4 border-b flex justify-between items-center"
                onClick={() => setSelectedTime(time)}
              >
                <span className="text-lg">{time}</span>
                <ChevronRightIcon size={20} className="text-gray-400" />
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div className="p-4 bg-white border-t">
        <Button 
          fullWidth
          size="lg"
          variant="primary"
          onClick={() => navigateTo('confirmation', { 
            salon: selectedSalon,
            service: selectedService,
            specialist: selectedSpecialist,
            date: `21 mar. 2025`,
            time: selectedTime
          })}
        >
          Continuă
        </Button>
      </div>
    </div>
  );
};

// Confirmation Screen component
export const ConfirmationScreen = () => {
  const { 
    selectedSalon, 
    selectedService, 
    selectedSpecialist, 
    selectedDate, 
    selectedTime, 
    navigateTo 
  } = useApp();
  
  if (!selectedSalon || !selectedService || !selectedSpecialist || !selectedDate || !selectedTime) {
    return (
      <div className="flex flex-col h-full items-center justify-center p-4">
        <p className="text-red-500">Information missing. Please go back and select all required options.</p>
        <Button 
          variant="primary"
          onClick={() => navigateTo('home')}
          className="mt-4"
        >
          Go Home
        </Button>
      </div>
    );
  }
  
  return (
    <div className="flex flex-col h-full">
      <SimpleHeader 
        title="Verifică și confirmă" 
        onBack={() => navigateTo('selectDate', { 
          salon: selectedSalon,
          service: selectedService,
          specialist: selectedSpecialist
        })}
      />
      
      <div className="flex-1 overflow-y-auto">
        <div className="p-4 border-b">
          <div className="flex items-center mb-3">
            <CalendarIcon size={20} className="text-gray-500 mr-2" />
            <div>
              <h3 className="text-lg font-bold">{selectedDate}, ora {selectedTime}</h3>
              <p className="text-gray-600">{selectedSpecialist.name} - {selectedSalon.name}</p>
            </div>
          </div>
        </div>
        
        <div className="p-4 border-b">
          <div className="flex items-center mb-3">
            <CheckIcon size={20} className="text-gray-500 mr-2" />
            <div className="flex-1">
              <h3 className="text-lg font-bold">{selectedService.name}</h3>
              <p className="text-gray-600">{selectedService.duration}, {selectedService.price}</p>
            </div>
          </div>
        </div>
        
        <div className="p-4 border-b">
          <div className="flex items-center mb-3">
            <CreditCardIcon size={20} className="text-gray-500 mr-2" />
            <div>
              <h3 className="text-lg font-bold">Plată în locație</h3>
              <p className="text-gray-600">Plătești la salon în numerar sau prin alte metode de plată puse la dispoziție.</p>
            </div>
          </div>
        </div>
        
        <div className="p-4">
          <button className="flex items-center text-blue-600">
            <span>Aplică cod reducere/card cadou</span>
            <ChevronRightIcon size={16} className="ml-1" />
          </button>
          
          <div className="mt-8">
            <div className="flex justify-between mb-2">
              <span className="text-xl font-bold">Total de plată</span>
              <span className="text-3xl font-bold">{selectedService.price}</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="p-4 bg-white border-t">
        <Button 
          fullWidth
          size="lg"
          variant="primary"
          onClick={() => navigateTo('home')}
        >
          Confirmă programarea
        </Button>
      </div>
    </div>
  );
};